
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deep-learning",
      function () {
        return require("private-next-pages/deep-learning.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deep-learning"])
      });
    }
  